module.exports = __webpack_public_path__ + "imgs/stopwatch.e1c2dd2a91186f7551a427daab473b0d.svg";